import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';
import { UpdateReminderSetting } from '../../dtos/reminderSetting/updateReminderSetting';
import { CreateReminderSetting } from 'app/dtos/reminderSetting/createReminderSetting';

@Injectable({
  providedIn: 'root'
})
export class ReminderSettingService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllReminderByIdSettings(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.ReminderSetting
    },id);
    return await firstValueFrom(observable);
  }

  async updateReminderSetting(updateReminderSetting:UpdateReminderSetting){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.ReminderSetting
    },updateReminderSetting);
    return await firstValueFrom(observable);
  }

  async createReminderSetting(createReminderSetting:CreateReminderSetting[]){
    var observable:Observable<any> = await this.httpClientService.post({
      controller:ControllerType.ReminderSetting
    },createReminderSetting);
    return await firstValueFrom(observable);
  }
}
